export const STEP_STATE = {
  ENABLED: 1,
  COMPLETED: 2,
  PENDING: 3,
  FAILED: 4,
  DISABLED: 5,
  ZAPSIGN: 6,
};
